import { toUnit } from '@/helpers/toUnit';
import { Header, RowData, flexRender } from '@tanstack/react-table';
import React, { CSSProperties } from 'react';

function TableHeader<TDataModel extends RowData>({
  header,
}: {
  header: Header<TDataModel, unknown>;
}) {
  const { size } = header.column.columnDef;

  // Better to remove the whole key & value in css rather than setting to 'auto' to prevent unexpected style
  const widthCss: CSSProperties = toUnit(size) ? { width: toUnit(size) } : {};

  const sizeStyle = { ...widthCss };

  return (
    <th key={header.id} colSpan={header.colSpan} style={sizeStyle}>
      {flexRender(header.column.columnDef.header, header.getContext())}
    </th>
  );
}

export default TableHeader;
